var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4135",
    "data-name": "Group 4135",
    transform: "translate(-337 -737)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6720",
    "data-name": "Rectangle 6720",
    width: 30,
    height: 30,
    rx: 5,
    transform: "translate(337 737)",
    fill: "#c2fae5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-delete-4920320",
    transform: "translate(334.648 734.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32560",
    "data-name": "Path 32560",
    d: "M22.783,21.171a.892.892,0,0,1,0,1.26l-.348.348a.892.892,0,0,1-1.26,0l-3.823-3.823-3.823,3.823a.891.891,0,0,1-1.26,0l-.348-.348a.892.892,0,0,1,0-1.26l3.823-3.823-3.823-3.823a.892.892,0,0,1,0-1.26l.348-.348a.891.891,0,0,1,1.26,0l3.823,3.823,3.823-3.823a.891.891,0,0,1,1.26,0l.348.348a.892.892,0,0,1,0,1.26l-3.823,3.824Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.7a3e655b28ad27531fdc2bba48bb76c6.svg";
export { ForwardRef as ReactComponent };